"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Range_1 = require("../../../core/model/math/Range");

var RangeConverter_1 = require("./RangeConverter");
/**
 * Default implementation of range converter.
 *
 * <br/>
 *
 * <b>Will be deprecated/removed in the future, replaced by BigNumberRangeConverter (within common general 'core' package).</b>
 *
 * @author RV
 */


var RangeConverterImpl =
/*#__PURE__*/
function (_RangeConverter_1$Ran) {
  _inherits(RangeConverterImpl, _RangeConverter_1$Ran);

  function RangeConverterImpl() {
    _classCallCheck(this, RangeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(RangeConverterImpl).apply(this, arguments));
  }

  _createClass(RangeConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Range_1.Range(conversions.toBigNumber(source.minimum), conversions.toBigNumber(source.maximum));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        minimum: conversions.fromBigNumber(source.minimum),
        maximum: conversions.fromBigNumber(source.maximum)
      });
      return result;
    }
  }]);

  return RangeConverterImpl;
}(RangeConverter_1.RangeConverter);

exports.RangeConverterImpl = RangeConverterImpl;